var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_418_4075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8148 7.79067C13.7012 6.48493 21.6731 3.59855 29.5076 6.82855C26.6212 3.1862 22.0854 0.849609 16.9999 0.849609C14.3884 0.849609 11.9831 1.46812 9.78394 2.56769C9.85266 3.80472 10.1276 5.72897 10.8148 7.79067Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9131 10.6086C24.0099 5.1794 14.7322 8.54685 11.7771 9.8526C12.808 11.9143 14.4573 13.976 17.0001 15.6254C19.1305 14.6632 26.5526 11.9143 33.1501 15.2817C32.9439 13.6324 32.5316 12.1205 31.9131 10.6086Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7279 15.9688C22.2918 16.0375 19.3366 17.137 18.0309 17.6868C18.3058 23.8719 13.4952 29.3698 10.8149 31.9813C12.3956 32.5998 14.0449 33.0122 15.8317 33.1496C25.3843 26.5522 25.8654 18.5802 25.7279 15.9688Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4263 25.1783C14.8008 22.9104 15.9004 20.2989 15.7629 17.55C9.64654 13.564 8.0659 7.44764 7.65356 3.87402C6.07292 4.9736 4.69845 6.34807 3.59888 7.99743C3.59888 11.571 4.62973 20.024 13.4263 25.1783Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1895 27.0333C4.9735 22.7725 2.49946 16.3812 1.7435 11.708C1.19371 13.3574 0.850098 15.1442 0.850098 16.9997C0.850098 22.8412 4.01137 27.9955 8.68457 30.8131C9.57797 30.0572 10.8837 28.7514 12.1895 27.0333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9958 16.0381C28.1333 19.0619 27.446 26.3466 19.749 32.944C27.1024 31.707 32.7377 25.5219 33.1501 17.8936C31.5007 16.8628 29.7139 16.313 27.9958 16.0381Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_418_4075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.59f4e51bd42719ccf0e0cc6208dc56d3.svg";
export { ForwardRef as ReactComponent };